@if (view$ | async; as view) {
  <span
    [ngClass]="{ converting: getExchangeRateRequestProcess.pending$ | async }"
  >
    @if (view.state === "error") {
      <mat-icon [matTooltip]="view.tooltip" inline>error</mat-icon>
    }
    <gax-money
      [roundingBehavior]="roundingBehavior"
      [amount]="view.money.amount"
      [currencyCode]="view.money.currencyCode"
    ></gax-money>
  </span>
}
